import React, { Children, useEffect, useState, useRef } from 'react'
import classes from "../Sigfox/SigFoxContentLayout.module.css";
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import RemoveCamectIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/trash.png"
import { deleteLiveViewCamera, unlinkSigfoxAPI } from '../../../../../../Api Methods/Api';
import { format } from 'date-fns';
import Lottie from 'lottie-react';
import areYouSure from '../../../../../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const LiveViewContentLayout = ({ camera, fetchVirtualSources }) => {
    console.log(camera)
    const { id, name, rtspURL, type, dateAdded, addedBy, siteUUID } = camera;

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const apiData = {
        token,
        client
    }

    const [showConfirmation, setShowConfirmation] = useState(false)

    const dispatch = useDispatch();
    const DeviceDetails = useSelector(state => state.service.DeviceDetails)

    const deleteCamera = async () => {
        setShowConfirmation(false)
        const responseData = await deleteLiveViewCamera(apiData, id, dispatch)
        if (responseData) {
            fetchVirtualSources();
        }
    }

    return (
        <>

         <Dialog
            header="Are you sure?"
            visible={showConfirmation}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirmation(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to delete this camera?`}</h3>
                <br />
                <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setShowConfirmation(false)} />
                <br />
                <Button label="Yes, delete camera" rounded icon="pi pi-check" severity="danger" onClick={() => deleteCamera()} />

            </div>
        </Dialog>

           <div className={classes.IntegrationContentLayout} >
                <div className={classes["left-wrapper"]}>
                    <h3 className={classes.integrationTitle}>{`Live view - ${type}`}</h3>
                    <h3 className={classes.subtitle}>
                    {name}
                    </h3>                    
                    <p style={{fontSize: "11px", fontStyle:"bold", margin:"0px", maxWidth:"220px"}} className={classes.subtitle}>{rtspURL}</p>

                        { addedBy && <small style={{fontSize: "9px", fontStyle:"italic", marginTop: "2px", maxWidth:"220px"}}>{`Added by ${addedBy} on ${format(new Date(dateAdded), "MMM do, yyyy")}`}</small>}
                    
                </div>

                <div className={classes["right-wrapper"]}>
                    <div className={classes["Icons-Container"]} >
                        <img className={classes.Icon} src={RemoveCamectIcon} onClick={() => setShowConfirmation(true)} />
                    </div>
                </div>
            </div >

        </>
    )
}

export default LiveViewContentLayout;




